import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setAppState } from '@cedalo/webui/src/actions/actions';
import { pathLogin, pathLogout } from '@cedalo/webui/src/actions/UserActions';
import gatewayClient from '@cedalo/webui/src/helper/GatewayClient';
import { intl } from '@cedalo/webui/src/helper/IntlGlobalProvider';
import MachineDetailPage from '@cedalo/webui/src/layouts/MachineDetailPage';
import ErrorPage from './ErrorPage';
import ConfigManager from '@cedalo/webui/src/helper/ConfigManager';
import { accessManager } from '@cedalo/webui/src/helper/AccessManager';

const CONFIG = ConfigManager.config.gatewayClientConfig;

const SHARED_MACHINE = `
query SharedMachine($id: ID!) {
	sharedMachine(id: $id) {
		code,
		success,
		link {
			machineId
		}
	}
}
`;

const getErrorMessage = (code) => {
	let message;
	switch (code) {
		case 'LINK_EXPIRED':
		case 'LINK_INVALID':
		case 'LINK_NOT_AVAILABLE':
			message = intl.formatMessage({ id: 'Extensions.SharedMachinePage.Error.LinkInvalid' });
			break;
		case 'MACHINE_NOT_AVAILABLE':
			message = intl.formatMessage({ id: 'Extensions.SharedMachinePage.Error.MachineInvalid' });
			break;
		default:
			message = 'Login failed! Link is invalid.';
	}
	return message;
};

const doLogin = async (props, path) => {
	try {
	} catch (error) {
		return false;
	}
};

const SharedMachinePage = (props) => {
	const {
		location,
		match: { params }
	} = props;
	const { linkId } = params;
	const [error, setError] = useState();
	const [machineId, setMachineId] = useState('');

	const setup = async () => {
		const alreadyLoggedIn = !!accessManager.authToken;
		let connected = false;
		try {
			if (alreadyLoggedIn) {
				await gatewayClient.connect(CONFIG);
				connected = true;
			} else {
				const resp = await props.pathLogin(location.pathname);
				if (resp.error && resp.error === 'LOGIN_REQUIRED') {
					window.location.href = `${window.location.origin}/login?redirect=${encodeURIComponent(
						props.location.pathname + props.location.search + props.location.hash
					)}`;
					return;
				}
				connected = !resp.error && !!resp.token;
			}
			if (!connected) throw Error(getErrorMessage('LINK_INVALID'));
			const { sharedMachine } = await gatewayClient.graphql(SHARED_MACHINE, { id: linkId });
			const { success, code, link } = sharedMachine;
			if (!success) throw new Error(getErrorMessage(code));
			setMachineId(link.machineId);
		} catch (err) {
			setError(err);
			// ensure we are connected or calling logout fails due to missing socket connection...
			if (connected && !alreadyLoggedIn) props.pathLogout();
		}
	};
	useEffect(() => {
		setup();
	}, []);

	// eslint-disable-next-line no-nested-ternary
	return machineId ? (
		<MachineDetailPage {...props} machineId={machineId} sharedMachine />
	) : error ? (
		<ErrorPage message={error.message} />
	) : null;
};

const mapDispatchToProps = { pathLogin, pathLogout, setAppState };

export default connect(undefined, mapDispatchToProps)(SharedMachinePage);



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/sharemachine/SharedMachinePage.js